export enum LegalRoutes {
  PRIVACY = 'privacy',
  TERMS = 'terms'
}
